import { theme } from '../../../../../core/theme/theme';

export const EditControlButtonStyles = (icon: string | undefined, backgroundSize: string | undefined) => {
    return {
        Button: {
            border: '0 none',
            boxShadow: '0 0 1px 1.5px rgba(0, 0, 0, 0.267)',
            marginRight: 12,
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 6,
            paddingRight: 6,
            width: '30px',
            height: '30px',
            fontSize: '10px',
            borderRadius: '2px',
            zIndex: 400,
            cursor: 'pointer',
            background: icon && `url('${icon}') white center no-repeat`,
            backgroundColor: theme.colors.default,
            backgroundSize: backgroundSize ? backgroundSize : '18px',
        } as const,
    };
};
